import React from 'react';
import { useNavigate } from 'react-router-dom';
import apiClient from '../services/apiClient';

const CustomerSupport = () => {
  const navigate = useNavigate();

  // ── Session validation ──
  React.useEffect(() => {
    const userStr = localStorage.getItem("user");
    if (!userStr) {
      navigate("/login");
      return;
    }
    try {
      const userObj = JSON.parse(userStr);
      if (userObj && userObj.exp) {
        const currentTime = Date.now() / 1000;
        if (userObj.exp < currentTime) {
          localStorage.removeItem("user");
          localStorage.removeItem("userMobile");
          navigate("/login");
        }
      }
    } catch (e) {
      localStorage.removeItem("user");
      localStorage.removeItem("userMobile");
      navigate("/login");
    }
  }, [navigate]);

  // Get current user email from localStorage
  const userStr = localStorage.getItem("user");
  let userEmail = "";
  if (userStr) {
    try {
      const userObj = JSON.parse(userStr);
      userEmail = userObj?.email || "";
    } catch (e) {
      console.error("Failed to parse user from localStorage", e);
    }
  }

  // ── Form state ──
  const [mobile, setMobile] = React.useState('');
  const [subject, setSubject] = React.useState('');
  const [details, setDetails] = React.useState('');
  const [errors, setErrors] = React.useState({});
  const [submitted, setSubmitted] = React.useState(false);
  const [submitting, setSubmitting] = React.useState(false);
  const [isMobile, setIsMobileView] = React.useState(window.innerWidth < 768);
  const [topic, setTopic] = React.useState('');

  React.useEffect(() => {
    const handleResize = () => setIsMobileView(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const validate = () => {
    const newErrors = {};
    if (!/^\d{10}$/.test(mobile)) {
      newErrors.mobile = 'Please enter a valid 10-digit mobile number';
    }
    if (!topic) {
      newErrors.topic = 'Please select a topic';
    }
    if (!subject.trim()) {
      newErrors.subject = 'Subject is required';
    } else if (subject.length > 20) {
      newErrors.subject = 'Subject cannot exceed 20 characters';
    }
    if (!details.trim()) {
      newErrors.details = 'Ticket details are required';
    } else if (details.length > 200) {
      newErrors.details = 'Details cannot exceed 200 characters';
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      setSubmitting(true);
      try {
        const htmlBody = `
          <div style="font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Helvetica, Arial, sans-serif; max-width: 600px; margin: 0 auto; background: #f8fafc; padding: 24px;">
            <div style="background: #1e293b; padding: 24px; border-radius: 8px 8px 0 0; text-align: left;">
              <h2 style="margin: 0; color: #ffffff; font-size: 20px; font-weight: 600; letter-spacing: -0.01em;">Customer Support Ticket</h2>
              <p style="margin: 6px 0 0; color: #94a3b8; font-size: 13px;">New support inquiry submitted via TrustApp</p>
            </div>
            <div style="background: #ffffff; padding: 24px; border: 1px solid #e2e8f0; border-top: none; border-radius: 0 0 8px 8px;">
              <table style="width: 100%; border-collapse: collapse; margin-bottom: 20px;">
                <tr>
                  <td style="padding: 12px 14px; background: #f8fafc; border: 1px solid #e2e8f0; font-weight: 600; color: #475569; width: 130px; font-size: 13px;">Mobile</td>
                  <td style="padding: 12px 14px; border: 1px solid #e2e8f0; color: #0f172a; font-size: 14px; font-weight: 500;">${mobile}</td>
                </tr>
                <tr>
                  <td style="padding: 12px 14px; background: #f8fafc; border: 1px solid #e2e8f0; font-weight: 600; color: #475569; font-size: 13px;">Topic</td>
                  <td style="padding: 12px 14px; border: 1px solid #e2e8f0; color: #0f172a; font-size: 14px;">${topic}</td>
                </tr>
                <tr>
                  <td style="padding: 12px 14px; background: #f8fafc; border: 1px solid #e2e8f0; font-weight: 600; color: #475569; font-size: 13px;">Subject</td>
                  <td style="padding: 12px 14px; border: 1px solid #e2e8f0; color: #0f172a; font-size: 14px; font-weight: 500;">${subject}</td>
                </tr>
                <tr>
                  <td style="padding: 12px 14px; background: #f8fafc; border: 1px solid #e2e8f0; font-weight: 600; color: #475569; vertical-align: top; font-size: 13px;">Details</td>
                  <td style="padding: 12px 14px; border: 1px solid #e2e8f0; color: #334155; font-size: 14px; line-height: 1.6;">${details.replace(/\n/g, '<br/>')}</td>
                </tr>
              </table>
              <div style="margin-top: 16px;">
                <a href="tel:+91${mobile}" style="display: inline-block; text-decoration: none; background: #2563eb; color: #ffffff; padding: 9px 18px; border-radius: 6px; font-size: 13px; font-weight: 600; margin-right: 10px;">Call Customer</a>
                <a href="https://wa.me/91${mobile}" style="display: inline-block; text-decoration: none; background: #16a34a; color: #ffffff; padding: 9px 18px; border-radius: 6px; font-size: 13px; font-weight: 600;">WhatsApp</a>
              </div>
            </div>
          </div>
        `;

        await apiClient.post('/v1/trust/sendEmail', {
          to: 'contact@cloudai.in',
          subject: `[Support Ticket] ${subject}`,
          phone: mobile,
          topic: topic,
          message: `Mobile: ${mobile}, Topic: ${topic}, Subject: ${subject}, Details: ${details}`,
          body: htmlBody,
          email: userEmail,
        });

        setSubmitted(true);
      } catch (err) {
        console.error('Email send error:', err);
        setErrors({ submit: 'Failed to send ticket. Please try again.' });
      } finally {
        setSubmitting(false);
      }
    }
  };

  const handleMobileChange = (e) => {
    const val = e.target.value.replace(/\D/g, '');
    if (val.length <= 10) setMobile(val);
  };

  // ── Shared styles ──
  const labelStyle = {
    display: 'block',
    fontSize: '0.85rem',
    fontWeight: '600',
    color: '#334155',
    marginBottom: '6px',
    letterSpacing: '0.01em',
  };

  const inputStyle = {
    width: '100%',
    padding: '11px 14px',
    fontSize: '0.925rem',
    color: '#0f172a',
    backgroundColor: '#ffffff',
    border: '1px solid #000000',
    borderRadius: '8px',
    outline: 'none',
    transition: 'border-color 0.15s ease, box-shadow 0.15s ease',
    fontFamily: 'Inter, sans-serif',
    boxSizing: 'border-box',
  };

  const inputFocusHandler = (e) => {
    e.currentTarget.style.borderColor = '#000000';
    e.currentTarget.style.boxShadow = '0 0 0 3px rgba(0, 0, 0, 0.08)';
  };
  const inputBlurHandler = (e) => {
    e.currentTarget.style.borderColor = '#000000';
    e.currentTarget.style.boxShadow = 'none';
  };

  const errorStyle = {
    color: '#dc2626',
    fontSize: '0.78rem',
    marginTop: '4px',
    fontWeight: '500',
  };

  const counterStyle = (current, max) => ({
    textAlign: 'right',
    fontSize: '0.75rem',
    color: current > max ? '#dc2626' : '#94a3b8',
    marginTop: '4px',
    fontWeight: '500',
  });

  const topics = [
    { label: 'Rent', icon: '🏠' },
    { label: 'Flat-Buy', icon: '🏢' },
    { label: 'Flat-Sale', icon: '🏷️' },
    { label: 'Distress sale', icon: '📉' },
    { label: 'Other support', icon: '💬' },
    { label: 'Any Delivery', icon: '🚚' },
    { label: 'Trips', icon: '🛣️' },
  ];

  // ── Success view ──
  if (submitted) {
    return (
      <div style={{
        fontFamily: 'Inter, sans-serif',
        minHeight: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: '#f8fafc',
        padding: '24px 16px',
      }}>
        <div style={{
          backgroundColor: '#ffffff',
          borderRadius: '16px',
          padding: isMobile ? '36px 24px' : '48px 44px',
          maxWidth: '480px',
          width: '100%',
          textAlign: 'center',
          boxShadow: '0 10px 25px -5px rgba(15, 23, 42, 0.08), 0 8px 10px -6px rgba(15, 23, 42, 0.04)',
          border: '1px solid #000000',
        }}>
          <div style={{
            width: '56px',
            height: '56px',
            borderRadius: '50%',
            backgroundColor: '#ecfdf5',
            border: '1px solid #a7f3d0',
            display: 'inline-flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '1.75rem',
            color: '#059669',
            marginBottom: '16px',
          }}>
            ✓
          </div>
          <h2 style={{
            color: '#0f172a',
            fontSize: '1.4rem',
            fontWeight: '700',
            marginTop: 0,
            marginBottom: '10px',
            letterSpacing: '-0.02em',
          }}>Ticket Submitted</h2>
          <p style={{
            color: '#64748b',
            fontSize: '0.925rem',
            lineHeight: '1.6',
            marginBottom: '28px',
          }}>
            Your support ticket has been received. Our team will review your inquiry and get back to you shortly.
          </p>
          <div style={{ display: 'flex', gap: '12px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <button
              onClick={() => {
                setMobile('');
                setSubject('');
                setDetails('');
                setTopic('');
                setErrors({});
                setSubmitted(false);
              }}
              style={{
                padding: '10px 20px',
                backgroundColor: '#2563eb',
                color: '#ffffff',
                border: '1px solid #000000',
                borderRadius: '8px',
                fontSize: '0.875rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'background-color 0.15s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#1d4ed8';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#2563eb';
              }}
            >Submit Another Ticket</button>
            <button
              onClick={() => navigate('/utility-dashboard')}
              style={{
                padding: '10px 20px',
                backgroundColor: '#ffffff',
                color: '#0f172a',
                border: '1px solid #000000',
                borderRadius: '8px',
                fontSize: '0.875rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f8fafc';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
              }}
            >Back to Dashboard</button>
          </div>
        </div>
      </div>
    );
  }

  // ── Form view ──
  return (
    <div style={{
      fontFamily: 'Inter, sans-serif',
      minHeight: '100vh',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: '#f8fafc',
      padding: '32px 16px',
    }}>
      <div style={{
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        padding: isMobile ? '28px 20px' : '36px 36px',
        maxWidth: '540px',
        width: '100%',
        boxShadow: '0 10px 25px -5px rgba(15, 23, 42, 0.08), 0 8px 10px -6px rgba(15, 23, 42, 0.04)',
        border: '1px solid #000000',
      }}>
        {/* Header */}
        <div style={{ textAlign: 'center', marginBottom: '28px' }}>
          <div style={{
            display: 'inline-flex',
            width: '48px',
            height: '48px',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: '12px',
            backgroundColor: '#eff6ff',
            border: '1px solid #000000',
            color: '#2563eb',
            fontSize: '1.4rem',
            marginBottom: '12px',
          }}>
            🎧
          </div>
          <h2 style={{
            margin: 0,
            fontSize: isMobile ? '1.35rem' : '1.5rem',
            fontWeight: '700',
            color: '#0f172a',
            letterSpacing: '-0.02em',
          }}>Customer Support</h2>
          <p style={{
            color: '#64748b',
            fontSize: '0.875rem',
            marginTop: '6px',
            marginBottom: 0,
            fontWeight: '400',
          }}>Submit a support ticket and our team will get back to you promptly.</p>
        </div>

        {errors.submit && (
          <div style={{
            backgroundColor: '#fef2f2',
            border: '1px solid #fecaca',
            color: '#991b1b',
            padding: '10px 14px',
            borderRadius: '8px',
            fontSize: '0.85rem',
            marginBottom: '20px',
          }}>
            {errors.submit}
          </div>
        )}

        <form onSubmit={handleSubmit} noValidate>
          {/* Mobile Number */}
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Mobile Number</label>
            <input
              type="tel"
              value={mobile}
              onChange={handleMobileChange}
              placeholder="Enter 10-digit mobile number"
              style={{
                ...inputStyle,
                ...(errors.mobile ? { borderColor: '#dc2626', boxShadow: '0 0 0 3px rgba(220, 38, 38, 0.1)' } : {}),
              }}
              onFocus={inputFocusHandler}
              onBlur={inputBlurHandler}
              inputMode="numeric"
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {errors.mobile
                ? <span style={errorStyle}>{errors.mobile}</span>
                : <span />
              }
              <span style={counterStyle(mobile.length, 10)}>{mobile.length}/10</span>
            </div>
          </div>

          {/* Topic */}
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Topic</label>
            <div style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(2, minmax(0, 1fr))',
              gap: '10px',
            }}>
              {topics.map(({ label, icon }) => {
                const isSelected = topic === label;
                return (
                  <label
                    key={label}
                    onClick={() => setTopic(label)}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px',
                      padding: '10px 12px',
                      borderRadius: '8px',
                      border: '1px solid #000000',
                      backgroundColor: isSelected ? '#f1f5f9' : '#ffffff',
                      cursor: 'pointer',
                      transition: 'all 0.15s ease',
                      fontSize: '0.85rem',
                      fontWeight: isSelected ? '600' : '500',
                      color: '#0f172a',
                      userSelect: 'none',
                      boxShadow: isSelected ? '0 1px 3px rgba(0, 0, 0, 0.1)' : 'none',
                    }}
                    onMouseEnter={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = '#f8fafc';
                      }
                    }}
                    onMouseLeave={(e) => {
                      if (!isSelected) {
                        e.currentTarget.style.backgroundColor = '#ffffff';
                      }
                    }}
                  >
                    <span style={{
                      fontSize: '1rem',
                      width: '28px',
                      height: '28px',
                      borderRadius: '6px',
                      backgroundColor: isSelected ? '#e2e8f0' : '#f1f5f9',
                      border: '1px solid #000000',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}>{icon}</span>
                    <span style={{ flex: 1, wordBreak: 'break-word', lineHeight: '1.3' }}>{label}</span>
                    <span style={{
                      width: '18px',
                      height: '18px',
                      borderRadius: '4px',
                      border: '1px solid #000000',
                      backgroundColor: isSelected ? '#000000' : '#ffffff',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      flexShrink: 0,
                    }}>
                      {isSelected && (
                        <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
                          <path d="M2 6L5 9L10 3" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      )}
                    </span>
                  </label>
                );
              })}
            </div>
            {errors.topic && <span style={{ ...errorStyle, display: 'block', marginTop: '6px' }}>{errors.topic}</span>}
          </div>

          {/* Subject */}
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Subject</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => {
                if (e.target.value.length <= 20) setSubject(e.target.value);
              }}
              placeholder="Brief summary of your inquiry"
              style={{
                ...inputStyle,
                ...(errors.subject ? { borderColor: '#dc2626', boxShadow: '0 0 0 3px rgba(220, 38, 38, 0.1)' } : {}),
              }}
              onFocus={inputFocusHandler}
              onBlur={inputBlurHandler}
              maxLength={20}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {errors.subject
                ? <span style={errorStyle}>{errors.subject}</span>
                : <span />
              }
              <span style={counterStyle(subject.length, 20)}>{subject.length}/20</span>
            </div>
          </div>

          {/* Ticket Details */}
          <div style={{ marginBottom: '24px' }}>
            <label style={labelStyle}>Ticket Details</label>
            <textarea
              value={details}
              onChange={(e) => {
                if (e.target.value.length <= 200) setDetails(e.target.value);
              }}
              placeholder="Please provide details about your request or issue..."
              rows={4}
              style={{
                ...inputStyle,
                resize: 'vertical',
                minHeight: '96px',
                ...(errors.details ? { borderColor: '#dc2626', boxShadow: '0 0 0 3px rgba(220, 38, 38, 0.1)' } : {}),
              }}
              onFocus={inputFocusHandler}
              onBlur={inputBlurHandler}
              maxLength={200}
            />
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              {errors.details
                ? <span style={errorStyle}>{errors.details}</span>
                : <span />
              }
              <span style={counterStyle(details.length, 200)}>{details.length}/200</span>
            </div>
          </div>

          {/* Buttons */}
          <div style={{ display: 'flex', gap: '12px', flexWrap: 'wrap' }}>
            <button
              type="submit"
              disabled={submitting}
              style={{
                flex: 1,
                minWidth: '140px',
                padding: '11px 20px',
                backgroundColor: '#2563eb',
                color: '#ffffff',
                border: '1px solid #000000',
                borderRadius: '8px',
                fontSize: '0.9rem',
                fontWeight: '600',
                cursor: submitting ? 'not-allowed' : 'pointer',
                opacity: submitting ? 0.7 : 1,
                transition: 'background-color 0.15s ease, box-shadow 0.15s ease',
                boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
              }}
              onMouseEnter={(e) => {
                if (!submitting) {
                  e.currentTarget.style.backgroundColor = '#1d4ed8';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(37, 99, 235, 0.2)';
                }
              }}
              onMouseLeave={(e) => {
                if (!submitting) {
                  e.currentTarget.style.backgroundColor = '#2563eb';
                  e.currentTarget.style.boxShadow = '0 1px 2px 0 rgba(0, 0, 0, 0.05)';
                }
              }}
            >
              {submitting ? 'Submitting...' : 'Submit Ticket'}
            </button>
            <button
              type="button"
              onClick={() => navigate('/utility-dashboard')}
              style={{
                flex: 1,
                minWidth: '140px',
                padding: '11px 20px',
                backgroundColor: '#ffffff',
                color: '#0f172a',
                border: '1px solid #000000',
                borderRadius: '8px',
                fontSize: '0.9rem',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.15s ease',
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = '#f8fafc';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = '#ffffff';
              }}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CustomerSupport;
